import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Typography,
} from "@mui/material";
import Layout from "../../components/layout/Layout";
import useAuth from "../../hooks/useAuth";
import dashboardApi from "../../api/dashboard";

// The legacy financial engine is global. Scoped operators use the authorized
// overview instead of loading global reports and silently swallowing HTTP 403s.
export default function KitchenOverview() {
  const { selectedKitchenId, kitchens } = useAuth();
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState("");
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    let active = true;
    setData(null);
    setError("");
    dashboardApi
      .getOverviewStats(selectedKitchenId || undefined)
      .then((result) => {
        if (active) setData(result);
      })
      .catch((e) => {
        if (active)
          setError(
            e?.response?.data?.message ||
              "Could not load the kitchen overview.",
          );
      });
    return () => {
      active = false;
    };
  }, [selectedKitchenId, refresh]);
  const name =
    kitchens?.find((k) => k._id === selectedKitchenId)?.name || "Your kitchen";
  return (
    <Layout>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4">Kitchen overview</Typography>
        <Typography sx={{ mb: 2 }}>{name}</Typography>
        <Alert severity="info" sx={{ mb: 2 }}>
          These figures cover your selected kitchen. Global financial reports
          require an admin or super-admin account.
        </Alert>
        <Button onClick={() => setRefresh((n) => n + 1)}>
          Refresh overview
        </Button>
        {error ? (
          <Alert severity="error">{error}</Alert>
        ) : !data ? (
          <CircularProgress aria-label="Loading kitchen overview" />
        ) : (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: 2,
              mt: 2,
            }}
          >
            {[
              [
                "Revenue",
                `₹${Number(data.totalRevenue || 0).toLocaleString("en-IN")}`,
              ],
              ["Active subscriptions", data.activeSubscriptions],
              ["Upcoming deliveries", data.upcomingOrders],
              ["Live instant orders", data.activeLiveOrders],
              ["Delivered orders", data.totalDeliveredOrders],
              ["Customers", data.totalUsers],
            ].map(([label, value]) => (
              <Card key={String(label)}>
                <CardContent>
                  <Typography color="text.secondary">{label}</Typography>
                  <Typography variant="h5">{value ?? 0}</Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Box>
    </Layout>
  );
}
